import React, { FC } from 'react'
import { usePortal } from '../hooks/usePortal'
import { useLocation } from 'react-router'
import queryString from 'query-string'
import Breadcrumbs from '../components/Breadcrumbs'
import { createPortal } from 'react-dom'
import Articles from '../components/Articles'
import getArticles from '../api/getArticles'
import ArticleCard from '../components/ArticleCard'
import { ArticleData } from '../server/utils/getArticlesData'
import IconTextBlock from '../components/IconTextBlock'
import { favoriteHandler } from '../utils/favoriteHandler'
import Btn from '../components/Btn'
import { ReactSVG } from 'react-svg'
import Status from '../components/Status'
import BtnIcon from "../components/BtnIcon";
import { EventModerationStatusEnum } from '../enums/EventModerationStatusEnum'
import { UserStore } from '../store/userStore'

const BREADCRUMBS = [
  {
    label: 'Главная',
    path: '/'
  },
  {
    label: 'Мероприятия',
    path: '/communities'
  }
]

const EventsPage: FC = () => {
  const { portal } = usePortal()

  const [activeTab, setActiveTab] = React.useState('')

  const location = useLocation()
  const isAddEventButtonVisible = UserStore.data?.canAddEvents;
  React.useEffect(() => {
    const parsed = queryString.parse(location.search)
    if (parsed.section) {
      setActiveTab(parsed.section.toString())
    } else {
      setActiveTab('')
    }
  }, [location.search])

  return (
    <div className="page">
      <Breadcrumbs className="page__breadcrumbs" breadcrumbs={BREADCRUMBS} />
      {portal &&
        createPortal(<Breadcrumbs breadcrumbs={BREADCRUMBS} />, portal)}

      <header className="page__head">
        <h1>Мероприятия</h1>

        <div className={'row row-gap-20'}>
          {isAddEventButtonVisible && <Btn outlined to={'/events/new'}>
            Добавить мероприятие
          </Btn>}
          

          <Btn to={'/news/new'}>
            <span>Опубликовать новость</span>
            <ReactSVG src={'/i/svg/plus.svg'} wrapper={'span'}></ReactSVG>
          </Btn>
        </div>
      </header>

      <div className="page__content">
        <Articles
          search
          tabsNavigation
          queryMode
          count={9}
          method={(options) => getArticles('/events/list', options)}
          renderContent={({ items }, loading, updateSections) => {
            return loading || items.length ? (
              <div className="app-grid _columns-3-1">
                {loading
                  ? Array.from({ length: 9 }).map((_, index) => {
                      return <ArticleCard key={index} loading />
                    })
                  : items.map((item: ArticleData) => (
                      <ArticleCard
                        favoriteHandler={async (value) => {
                          await favoriteHandler(
                            value,
                            item.id as string,
                            'events'
                          )
                          await updateSections()
                        }}
                        key={item.id}
                        favorite={item.favorite}
                        tags={item.tags || []}
                        title={item.title}
                        picture={
                          item.previewPicture || item.detailPicture || ''
                        }
                        startDate={item.startDate || ''}
                        to={`/events/${item.id}`}
                        renderFoot={() => {
                          let status = null

                          if (activeTab === 'moderation') {
                            status = EventModerationStatusEnum.items.find((statusItem) => item.moderationStatusId === statusItem.id)
                          }
                          return (
                            <>
                              <IconTextBlock list={item.informationItems} />
                              <div className={'article-card__actions'}>
                                {activeTab === 'moderation' && status && (
                                  <Status
                                    label={status.name}
                                    color={status.color}
                                    icon={status.icon}
                                    message={item.moderationStatusMessage}
                                  />
                                )}

                                {item.isEditable && (
                                  <BtnIcon to={`/events/${item.id}/edit`} filled>
                                    <ReactSVG src={'/i/svg/pencil.svg'} wrapper={'span'} />
                                  </BtnIcon>
                                )}
                              </div>
                            </>
                          )
                        }}
                        // renderFoot={() => (
                        //   <>
                        //     <IconTextBlock list={item.informationItems} />
                        //     {activeTab === 'moderation' && (
                        //       <div className={'article-card__actions'}>
                        //         <Status
                        //           id={item.moderationStatusId}
                        //           message={item.moderationStatusMessage}
                        //         />
                        //         {item.moderationStatusId === EventModerationStatusEnum.Error.id && (
                        //           <BtnIcon
                        //             to={`/events/${item.id}/edit`}
                        //             filled
                        //           >
                        //             <ReactSVG
                        //               src={'/i/svg/pencil.svg'}
                        //               wrapper={'span'}
                        //             />
                        //           </BtnIcon>
                        //         )}
                        //       </div>
                        //     )}
                        //   </>
                        // )}
                      />
                    ))}
              </div>
            ) : (
              'Нет данных'
            )
          }}
        />
      </div>
    </div>
  )
}

export default EventsPage
